<template>
  <div
    @mouseover="hovering = true"
    @mouseleave="hovering = false"
    style="min-width: 200px;"
  >
    <label v-show="!question.is_list && fieldType.text !== null">
      <span v-html="fieldType.text"></span>
      <v-icon
        v-if="fieldType.required"
        size="10"
        color="red"
        style="vertical-align:middle;padding-left: 10px;"
      >
        mdi-asterisk
      </v-icon>
    </label>
    <div class="input-group">
      <v-radio-group
        v-model="value"
        v-bind:prepend-icon="(answer.status) ? statusIconClass : null"
        v-bind:background-color="(answer.status === 'follow up' || highlightNoAnswer) ? '#ffffcc' : 'white'"
        :rules="isRequired ? [v => !!v || 'Required'] : []"
        :aria-label="fieldType.text || question.text"
        row
        style="width:100%;"
        @change="save"
      >
        <v-layout row wrap>
          <v-flex
            v-for="option in fieldType.options"
            :key="option.id"
            xs12
            :sm6="optionListMaxLen <= 150"
            :md3="optionListMaxLen <= 150"
            :class="{'single-col-opt': optionListMaxLen > 150}"
          >
            <v-radio
              :disabled="readonly"
              :label="option.text"
              :value="option.id"
            />
          </v-flex>
        </v-layout>
        <a
          v-if="value && !readonly"
          style="padding-right:20px;"
          @click="reset"
        >
          Reset
        </a>
      </v-radio-group>
      <slot></slot>
    </div>
    <TryAgain
      v-if="failed"
      :message="'Save'"
      @try="save"
    />
  </div>
</template>

<script>
import answerMixin from './answermixin'
import TryAgain from './TryAgain'

export default {
  name: 'RadioAnswer',
  mixins: [answerMixin],
  props: [ 'readonly' ],
  components: { TryAgain },
  data () {
    return {
      value: null,
      savedValue: null,
      failed: false,
      menu: false
    }
  },
  beforeMount () {
    this.value = this.answer.option || null
    this.savedValue = this.answer.option || null
  },
  methods: {
    reset () {
      this.value = null
      this.save()
    }
  }
}
</script>

<style>
.follow-up select {
  background-color: #ffffcc;
}

.v-input--selection-controls .v-input__control {
  width: 100% !important;
}

.single-col-opt {
  margin-bottom: 15px;
}
</style>
